// B4 ② 차량 정보 — 필수는 차종 하나. OCR 프리필이면 앰버 배너 + 첨부 장수.
// 연료 전송값은 앱과 같은 한국어 원문(가솔린/디젤/LPG/하이브리드/전기), 라벨만 번역한다.
import React from 'react';
import { Field, AmberBox, CtaBar, input, select, btnNavy, btnPlain, warnSt } from './bits';

// value = 서버로 가는 원문, labelKey = 표시 라벨(LPG 는 4개 언어 모두 'LPG' — 키 없음).
export var FUELS = [
  { value: '가솔린', labelKey: 'evalFuelGasoline' },
  { value: '디젤', labelKey: 'evalFuelDiesel' },
  { value: 'LPG', labelKey: '' },
  { value: '하이브리드', labelKey: 'evalFuelHybrid' },
  { value: '전기', labelKey: 'evalFuelElectric' }
];

function StepVehicle(props) {
  var t = props.t;
  var f = props.form;
  var set = props.onChange;
  var grid = { display: 'grid', gridTemplateColumns: props.isMobile ? '1fr' : '1fr 1fr', gap: '12px 14px' };

  return (<React.Fragment>
    {props.ocrFilled ? (<AmberBox title={t('simpleOcrFilled')}
      sub={props.photoCount ? t('inspPhotoCount', { count: props.photoCount }) : ''} />) : null}

    <Field label={t('evalFormModel')} required htmlFor="req-model" error={props.modelError}>
      <input id="req-model" style={input} value={f.car_model} placeholder={t('evalFormModelHint')}
        onChange={function (e) { set('car_model', e.target.value); }} />
    </Field>

    <div style={grid}>
      <Field label={t('evalFormDetail')} htmlFor="req-detail">
        <input id="req-detail" style={input} value={f.car_detail} onChange={function (e) { set('car_detail', e.target.value); }} />
      </Field>
      <Field label={t('evalFormCarNumber')} htmlFor="req-plate">
        <input id="req-plate" dir="ltr" style={input} value={f.car_number} onChange={function (e) { set('car_number', e.target.value); }} />
      </Field>
      <Field label={t('evalFormYear')} htmlFor="req-year">
        <input id="req-year" dir="ltr" inputMode="numeric" style={input} value={f.car_year} onChange={function (e) { set('car_year', e.target.value); }} />
      </Field>
      <Field label={t('evalFormMileage')} htmlFor="req-mileage">
        <input id="req-mileage" dir="ltr" inputMode="numeric" style={input} value={f.car_mileage} onChange={function (e) { set('car_mileage', e.target.value); }} />
      </Field>
      <Field label={t('evalFormSellerPhone')} htmlFor="req-phone">
        <input id="req-phone" dir="ltr" inputMode="tel" style={input} value={f.seller_phone} onChange={function (e) { set('seller_phone', e.target.value); }} />
      </Field>
      <Field label={t('evalFormFuel')} htmlFor="req-fuel">
        <select id="req-fuel" style={select} value={f.car_fuel} onChange={function (e) { set('car_fuel', e.target.value); }}>
          {FUELS.map(function (o) {
            return <option key={o.value} value={o.value}>{o.labelKey ? t(o.labelKey) : o.value}</option>;
          })}
        </select>
      </Field>
    </div>

    {props.plateMissing ? <div style={warnSt}>{t('simpleB3PlateMissing')}</div> : null}

    <CtaBar isMobile={props.isMobile}>
      <button type="button" style={props.isMobile ? Object.assign({}, btnPlain, { flex: 1 }) : btnPlain}
        onClick={props.onBack}>{t('actionBack')}</button>
      <button type="button" data-testid="vehicle-next" style={props.isMobile ? Object.assign({}, btnNavy, { flex: 2 }) : btnNavy}
        onClick={props.onNext}>{t('actionNext')}</button>
    </CtaBar>
  </React.Fragment>);
}

export default StepVehicle;
